import React, { useState } from "react"
import types from "prop-types"
import Formsy from "formsy-react"
import { PrimaryButton, TertiaryButton } from "shared/buttons"
import FieldLabel from "shared/FieldLabel"
import { FormsyMultilineTextInput } from "shared/inputs"

const RESOLUTION_FORM_ID = "conversation-form"

const ResolutionForm = ({ initialValues = {}, onCancel, onSubmit }) => {
  const [formIsValid, setFormIsValid] = useState(false)

  const disableSubmit = () => setFormIsValid(false)
  const enableSubmit = () => setFormIsValid(true)

  const { text } = initialValues

  return (
    <Formsy
      id={RESOLUTION_FORM_ID}
      onInvalid={disableSubmit}
      onSubmit={onSubmit}
      onValid={enableSubmit}
    >
      <div className="flex flex-col gap-8">
        <FieldLabel className="w-full !max-w-full" text="Resolution Text">
          <FormsyMultilineTextInput
            className="bordered-base-input text-sm h-32 overflow-y-auto thin-scrollbar transparent-scroll-track"
            name="text"
            placeholder="Resolution ..."
            required
            validations={{
              isNotBlankString: true,
              noExcelMetacharacters: true,
              noHTML: true,
            }}
            validationErrors={{ isDefaultRequiredValue: "required" }}
            value={text}
          />
        </FieldLabel>
        <div className="flex items-center justify-center gap-2">
          <TertiaryButton
            ariaLabel="cancel"
            onClick={onCancel}
            text="Cancel"
          />
          <PrimaryButton
            ariaLabel="submit resolution form"
            disabled={!formIsValid}
            form={RESOLUTION_FORM_ID}
            text="Submit"
            type="submit"
          />
        </div>
      </div>
    </Formsy>
  )
}

ResolutionForm.propTypes = {
  initialValues: types.object,
  onCancel: types.func.isRequired,
  onSubmit: types.func.isRequired,
}

export default ResolutionForm
